<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big queue" [innerHtml]="'MODAL_2GO_OFFER_MODAL_TITLE' | translate | safeHtml"></div>
    </div>
    <div class="body">
        <div class="section queue-section estimate">
            <div class="section-column">
                <p [innerHtml]="'MODAL_2GO_OFFER_REMAINDER' | translate | safeHtml"></p>
                <div class="estimation-placeholder">
                    <p class="estimation" *ngIf='this?.ref?.data?.queue && this.timerFormat && this.timer?.asMilliseconds() > 0'> {{ this.timerFormat }} </p>
                    <p class="estimation" *ngIf='this?.ref?.data?.queue && this.timerFormat && this.timer?.asMilliseconds() <= 0'>{{ 'MODAL_2GO_TIMER_OVER' | translate}}</p>
                </div>                
                <button id="modal-size-premium-button-freemium" class="btn-new red cta-send" [disabled]="(status$ | async) !== 'Resumable'"
                    (click)="onUploadAnonymous()" translate>MODAL_2GO_BUTTON_SEND_FILES_FREE</button>
            </div>
        </div>
        <div class="section queue-section insentive">
            <div class="decoration">
                <div class="rocket"></div>
            </div>
            <div class="section-column">
                <div class="offer" [innerHtml]="'MODAL_2GO_OFFER_TEXT' | translate | safeHtml">
                </div>

                <div class="deal-container">
                    <div class="deal-block">
                        <div class="deal-block-inner">
                            <div class="deal-title" translate>MODAL_2GO_OFFER_TITLE</div>
                            <div class="deal-offer" *ngIf="smashPremiumOffer">-{{ smashPremiumDiscount }}<span>%</span></div>

                        </div>
                        <div class="deal-tag">
                            <div class="tag-vertical"></div>
                            <div class="tag"></div>
                            <div class="tag-vertical"></div>
                        </div>
                        
                    </div>
                    <div class="deal-block">
                        <ng-container *ngIf="!smashPremiumOffer">
                            <div class="loading-spinner-container">
                                <div class="loading-spinner-grey"></div>
                            </div>
                        </ng-container>
                        <div *ngIf="smashPremiumOffer" class="plan">
                            <span class="value" [ngClass]="smashPremiumCurrency">{{ smashPremiumOffer | priceFormater : {language: language$ | async , currency: smashPremiumCurrency }  }}</span>
                            <span class="period">/{{ 'MODAL_2GO_MONTH' | translate }}</span>
                        </div>
                    </div>
                </div>
                <div class="deal-footer">
                    <div class="line"></div>
                    <a id="modal-size-premium-link-pricing" class="btn-v3 orange cta-special"
                        (click)="goSubscribe($event, 'MODAL_2GO_BUTTON_SUBSCRIBE_LINK' )">
                        {{ 'MODAL_2GO_BUTTON_SUBSCRIBE' | translate }}
                    </a>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div>
</div>